import { render, staticRenderFns } from "./WhyUsSection.vue?vue&type=template&id=804102dc&scoped=true"
import script from "./WhyUsSection.vue?vue&type=script&lang=js"
export * from "./WhyUsSection.vue?vue&type=script&lang=js"
import style0 from "./WhyUsSection.vue?vue&type=style&index=0&id=804102dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "804102dc",
  null
  
)

export default component.exports